import { create } from "zustand";
import { persist } from "zustand/middleware";
import { jwtDecode } from "jwt-decode";

type AuthStore = {
  user: any;
  token: string | null;
  authInfo: { merchants: { id: number; name: string; state: string }[] };
  login: (token: string) => void;
  logout: () => void;
  setAuthInfo: (data: { merchants: { id: number; name: string; state: string }[] }) => void;
};

export const useAuthStore = create<AuthStore>()(
  persist(
    set => ({
      user: null,
      token: null,
      authInfo: { merchants: [] },
      login: (token: string) => {
        const user = jwtDecode(token);

        set({ user, token });
      },
      logout: () => set({ user: null, token: null }),
      setAuthInfo: data => set(state => ({ ...state, authInfo: data })),
    }),
    {
      name: "AUTH_STORE",
    }
  )
);
